module.exports = __webpack_public_path__ + "img/4-5.4e8bbf3b.png";